import { WorkflowRun } from '../../useWorkflowRuns';
import { RollbackOptionsValue } from './types';

export const prepareRollbackOptions = (runs: WorkflowRun[]) => {
  const successfulBuilds = runs.filter(build => build.status === 'SUCCESS');

  // Group by environment (_ENVIRONMENT from substitutions) if specified
  const buildsByEnvironment: Record<string, WorkflowRun[]> = {};

  successfulBuilds.forEach(build => {
    const environment =
      build.substitutions._ENVIRONMENT ??
      build.substitutions._ENV ??
      'unspecified';
    if (!buildsByEnvironment[environment]) {
      buildsByEnvironment[environment] = [];
    }
    buildsByEnvironment[environment].push(build);
  });

  // For each environment, sort by most recent createTime and extract details
  const rollbackOptions: Record<string, RollbackOptionsValue[]> = {};

  Object.keys(buildsByEnvironment).forEach(env => {
    const sortedBuilds = buildsByEnvironment[env].sort(
      (a, b) => parseInt(b.createTime, 10) - parseInt(a.createTime, 10),
    );

    rollbackOptions[env] = sortedBuilds.map(build => {
      return {
        runId: build.id,
        triggerName: build.substitutions.TRIGGER_NAME,
        shortSha: build.substitutions.SHORT_SHA,
        ref: build.substitutions.REF_NAME,
        tag: build.substitutions.TAG_NAME,
        module: build.substitutions._MODULE,
        createTime: build.createTime,
        url: build.url,
      };
    });
  });

  return rollbackOptions;
};

export const parseDateFromStringSeconds = (dateString?: string) => {
  if (!dateString) {
    return '';
  }
  try {
    const time = parseInt(dateString, 10);
    const date = new Date(time * 1000);
    const formattedDate = date.toLocaleString(navigator.language, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    return formattedDate;
  } catch {
    return '';
  }
};
